module.exports = __webpack_public_path__ + "static/media/marker-icon-2x-cd0000.1e8c1327.png";